<template>
  <section
    :class="{
      'Chat-entry': true,
      'Chat-entry--is-unhandled': !messageEntry.isHandled,
      'Chat-entry--is-me': isMe,
      'Chat-entry--first': isFirst
    }"
  >
    <h4 class="Chat-entry__posted-at">{{ postedAtFormatted }}</h4>
    <div class="Chat-entry__content">
      <div class="Chat-entry__inner-bubble">
        <div class="Chat-entry__sender">{{ messageEntry.from }}</div>
        <div class="Chat-entry__message">{{ messageEntry.message }}</div>
      </div>
      <a
        v-if="
          !messageEntry.isHandled &&
            !isSubmitLoading &&
            !disabled &&
            !isApplicant
        "
        @click.prevent="markAsHandled"
        href="#"
        class="Chat-entry__mark-as-handled"
        >Markera som löst</a
      >
    </div>
  </section>
</template>

<script>
import { format } from "date-fns";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ApplicationActionCommentsEntry",
  props: {
    messageEntry: {
      type: Object,
      required: true
    },
    actionId: {
      type: String,
      required: true
    },
    i: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSubmitLoading: false
    };
  },
  computed: {
    ...mapGetters("memberStore", ["isApplicant"]),
    postedAtFormatted() {
      return format(
        new Date(this.messageEntry.postedAt),
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    isMe() {
      // TODO this should be changed if
      // this app is going to be used by aspirants
      return this.messageEntry.postedByAdmin;
    },
    isFirst() {
      return this.i === 0;
    }
  },
  methods: {
    ...mapActions("applicationStore", ["markActionMessageAsHandled"]),
    markAsHandled() {
      const args = { actionId: this.actionId, messageId: this.messageEntry.id };
      this.isSubmitLoading = true;
      this.markActionMessageAsHandled(args)
        .then(() => {
          this.isSubmitLoading = false;
        })
        .catch(e => {
          this.isSubmitLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$chat-arrow-inner-width: 7px;
$chat-arrow-outer-width: 8px;

.Chat-entry {
  float: left;
  clear: both;
  max-width: 70%;
  margin-top: $spacing;

  &__posted-at {
    @extend %title-XS;
    color: $color-half-opaque-black;
    margin-bottom: $spacing/4;
  }

  &__content {
    display: flex;
  }
  &__inner-bubble {
    position: relative;
    padding: $gutter;
    border-radius: $border-radius-default;
    border: $border-default;
    background-color: $color-pale-grey;

    &:after {
      content: " ";
      position: absolute;
      top: 50%;
      left: -#{$chat-arrow-inner-width};
      right: auto;
      transform: translateY(-50%);
      width: 0;
      height: 0;

      border-top-color: transparent;
      border-top-width: $chat-arrow-inner-width;
      border-top-style: solid;

      border-right-color: $color-pale-grey;
      border-right-width: $chat-arrow-inner-width;
      border-right-style: solid;

      border-bottom-color: transparent;
      border-bottom-width: $chat-arrow-inner-width;
      border-bottom-style: solid;

      border-left-color: transparent;
      border-left-width: 0;
      border-left-style: none;
    }
    &:before {
      content: " ";
      position: absolute;
      top: 50%;
      left: -#{$chat-arrow-outer-width};
      right: auto;
      transform: translateY(-50%);
      width: 0;
      height: 0;

      border-top-color: transparent;
      border-top-width: $chat-arrow-outer-width;
      border-top-style: solid;

      border-right-color: $color-border;
      border-right-width: $chat-arrow-outer-width;
      border-right-style: solid;

      border-bottom-color: transparent;
      border-bottom-width: $chat-arrow-outer-width;
      border-bottom-style: solid;

      border-left-color: transparent;
      border-left-width: 0;
      border-left-style: none;
    }
  }
  &__mark-as-handled {
    @extend %text-XS;
    align-self: center;
    padding: 0 0 0 $gutter/2;
    color: $color-nice-blue;
    text-decoration: underline;
    font-weight: $font-bold;
    white-space: nowrap;
    &:before {
      content: " ";
      display: inline-block;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: $color-nice-blue;
      margin-right: 6px;
    }
  }
  &__sender {
    @extend %title-XS;
    color: $color-half-opaque-black;
    margin-bottom: $spacing/4;
    text-transform: uppercase;
  }
  &__message {
    @extend %text-S;
  }
  &--is-me {
    float: right;
    .Chat-entry__posted-at {
      text-align: right;
    }
    .Chat-entry__content {
      flex-flow: row-reverse;
    }
    .Chat-entry__mark-as-handled {
      padding: 0 $gutter/2 0 0;
    }
    .Chat-entry__inner-bubble {
      background-color: $color-white-two;
      border-color: $color-border;
      &:after {
        left: auto;
        right: -#{$chat-arrow-inner-width};

        border-right-width: 0;
        border-right-style: none;

        border-left-color: $color-white-two;
        border-left-width: $chat-arrow-inner-width;
        border-left-style: solid;
      }
      &:before {
        left: auto;
        right: -#{$chat-arrow-outer-width};

        border-right-width: 0;
        border-right-style: none;

        border-left-color: $color-border;
        border-left-width: $chat-arrow-outer-width;
        border-left-style: solid;
      }
    }
  }

  &--first {
    margin-top: 0;
  }
}
</style>
